<ax-value-edit
  type="NUMBER"
  [form]="valueControl"
  [name]="name"
  [autofocus]="autofocus"
  [label]="label"
  [hint]="hint"
  [required]="required"
  [icon]="showIcon ? customIcon ?? 'numeric' : undefined"
  [errorsTemplate]="errorsTemplate"
  [readonly]="readonly"
  [subscriptSizing]="subscriptSizing"
></ax-value-edit>

<ng-template #errorsTemplate>
  <ax-property-error [form]="form" [label]="label"></ax-property-error>
</ng-template>
